<template>
	<span
		class="copyright rich-text"
		v-html="footerCopy"
	/>
</template>

<script lang="ts" src="./copyright.ts"></script>
